/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import qr from 'qr-encode';
import {Dialog} from 'react-weui';
import {WKOwnDialog} from '../wk'
import '../../css/common/AideDialog.css';

class AideDialog extends Component {
    constructor() {
        super();

        this.handleGetKey = this.handleGetKey.bind(this);
        this.AIDE_DIALOG_KEY = 'wkAideDialog-';
        this.state = {
            show: true,
            buttons: [
                {
                    type: 'primary',
                    label: '我知道了',
                    onClick: this.handleHideDialog.bind(this)
                }
            ]
        }
    }

    handleGetKey() {
        let date = new Date(),
            month = date.getMonth() + 1,
            day = date.getDate();
        return this.AIDE_DIALOG_KEY + month + day;
    }

    handleHideDialog() {
        this.setState({show: false});
        let key = this.handleGetKey();
        localStorage.setItem(key, true);
        localStorage.wkAideDialogCloseNum = localStorage.wkAideDialogCloseNum ? parseInt(localStorage.wkAideDialogCloseNum, 10) + 1 : 1;
    }

    componentWillMount() {
        let key = this.handleGetKey();
        if (localStorage.getItem(key) || parseInt(localStorage.wkAideDialogCloseNum, 10) >= 2) {
            this.setState({show: false});
        }
    }

    render() {
        const {show, buttons} = this.state;
        const {qrcode} = this.props;
        if (!show) {
            return null;
        }

        return (
            <div className="aide-dialog">
                <WKOwnDialog type="ios" show={show} buttons={buttons}>
                    <p className="content__qrcode"><img src={qr(qrcode)} alt=""/></p>

                    <p>长按扫码关注微课大学<br/>加入月入10万讲师团</p>
                </WKOwnDialog>
            </div>
        )
    }
}

export default AideDialog;


// WEBPACK FOOTER //
// ./src/components/common/AideDialog.js